import apiSlice from "./apiSlice";
const settingsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addSettings: builder.mutation({
      query: ({ body }) => ({
        url: `Settings`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["AllSettings"],
    }),
    getAllSettings: builder.query({
      query: (req) => ({
        url: `Settings`,
        params: req,
      })
    }),
    updateSettings: builder.mutation({
      query: ({ id, body }) => ({
        url: `Settings/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["AllSettings"],
    }),
    deleteSettings: builder.mutation({
      query: ({id, body}) => ({
        url: `Settings/${id}`,
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["AllSettings"],
    }),
  }),
});

export const {
  useGetAllSettingsQuery,
  useAddSettingsMutation,
  useUpdateSettingsMutation,
  useDeleteSettingsMutation,
} = settingsApiSlice;
